import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

import { typeStyles } from "../tokens";
import guide from "../tokens/tokens.json";

// tailwind-merge only knows Tailwind's default scales; without these, `text-ui` reads as a
// text color and a later `text-white` would drop it.
const twMerge = extendTailwindMerge({
  extend: {
    theme: { spacing: guide.size.tokens.map(({ name }) => name) },
    classGroups: {
      "font-size": [{ text: typeStyles.map(({ name }) => name) }],
      shadow: [{ shadow: ["hover", "float"] }],
    },
  },
});

// Later classes win over conflicting earlier ones, so callers can override defaults.
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
